import React, {Component} from 'react'
import PropTypes from "prop-types";
import utils from "../../utils/utils";
import Constants from "../../utils/constants";
import PatientSelectComponent from "../single_components/PatientSelectComponent";
import Error from "../single_components/Error";
import AlertConfirm from "../modals/Confirm";
import Select from "react-select";

class PhysicalExam extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,

        }
    }
    componentDidMount() {



    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }



    render() {
        let {t} = this.props

        let {entry}= this.state

        return (
            <div className={'patientsFormBoxes'}>
                <div className={'patientsFormRow-high'}>
                    <div className={'inputSlotsDoc-full'}>
{/*
                        <label className={'infoLabel'}>{t('patient_boarding.physical_examination')}</label>
*/}
                        <textarea  className={'info-inputBoxStyle-visitSummary boxMargin'} defaultValue={entry.physical_examination} maxLength={"5000"}
                                   onChange={(event) => this.props.onValueChange("physical_examination", event.target.value)}/>
                    </div>
                </div>

            </div>

        )
    }
}

PhysicalExam.propTypes = {
    onValueChange:PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default PhysicalExam;
